import React from 'react';
import ModuleLayout from '../../layouts/ModuleLayout';
import { WasteTrackingList } from '../../components/Admin/Inventory/WasteTracking';

export default function WasteTrackingPage() {
  return (
    <ModuleLayout>
      <WasteTrackingList />
    </ModuleLayout>
  );
}
